import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';
// Revalidation SWR-style 5 min ; l'impression est comptée côté backend
// à chaque fetch, on ne veut donc pas poller plus souvent.
const REFRESH_INTERVAL_MS = 5 * 60 * 1000;

/**
 * Hook public pour récupérer la pub active d'un placement.
 *
 * Retourne { ad, loading, error, refresh }.
 * Si aucune pub active → ad = null (les composants consommateurs
 * masquent alors leur section).
 */
export default function useActiveAd(placement) {
  const [ad, setAd] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const timerRef = useRef(null);

  const fetchAd = useCallback(async () => {
    try {
      const res = await axios.get(`${API_URL}/api/ads/active/${placement}`, {
        timeout: 6000,
      });
      setAd(res.data || null);
      setError(null);
    } catch (e) {
      setError(e);
      setAd(null);
    } finally {
      setLoading(false);
    }
  }, [placement]);

  useEffect(() => {
    fetchAd();
    timerRef.current = setInterval(fetchAd, REFRESH_INTERVAL_MS);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [fetchAd]);

  return { ad, loading, error, refresh: fetchAd };
}
